import {
  sidebarItemClassName,
  sidebarNavigationTheme,
  sidebarItemGroupClassName,
} from "./sidebar-styles";
import {
  Sidebar,
  SidebarItems,
  SidebarItemGroup,
  SidebarItem,
  TextInput,
} from "flowbite-react";
import type { FC } from "react";
import { useEffect, useState } from "react";
import {
  HiSearch,
  HiLocationMarker,
  HiClipboardList,
} from "react-icons/hi";

const SpecificRoleSidebar: FC = function () {
  const [currentPage, setCurrentPage] = useState("");

  useEffect(() => {
    const newPage = window.location.pathname;
    setCurrentPage(newPage);
  }, [setCurrentPage]);

  return (
    <Sidebar
      theme={sidebarNavigationTheme}
      aria-label="Seitenleiste für spezifische Rolle"
      className="h-full overflow-y-auto border-none bg-transparent py-3"
    >
      <SidebarItems>
        <form className="mb-4 px-3 lg:hidden">
          <TextInput
            icon={HiSearch}
            type="search"
            placeholder="Suchen"
            required
            size={32}
            className="touch-manipulation sentry-unmask"
          />
        </form>
        <SidebarItemGroup className={sidebarItemGroupClassName}>
          <SidebarItem
            href="/location_variant"
            icon={HiLocationMarker}
            className={`
              ${sidebarItemClassName}
              ${
                "/location_variant" === currentPage
                  ? "bg-gray-100 dark:bg-gray-700"
                  : ""
              }
            `}
          >
            Standort
          </SidebarItem>
          <SidebarItem
            href="/contract_creation_variant"
            icon={HiClipboardList}
            className={`
              ${sidebarItemClassName}
              ${
                "/contract_creation_variant" === currentPage
                  ? "bg-gray-100 dark:bg-gray-700"
                  : ""
              }
            `}
          >
            Straßenliste
          </SidebarItem>
        </SidebarItemGroup>
      </SidebarItems>
    </Sidebar>
  );
};

export default SpecificRoleSidebar;
